package meineglasfaser.api.routes

import io.ktor.resources.*
import kotlinx.serialization.Serializable
import meineglasfaser.api.IncidentLevel
import meineglasfaser.api.IncidentStatus
import kotlin.time.Instant

@Serializable
data class PublicIncident(
    val id: String,
    val level: IncidentLevel,
    val status: IncidentStatus,
    val title: String,
    val message: String,
    val affectedName: String,
    val createdAt: Instant,
    val events: List<PublicIncidentEvent>,
)

@Serializable
data class PublicIncidentEvent(
    val id: String,
    val level: IncidentLevel,
    val status: IncidentStatus,
    val message: String,
    val createdAt: Instant,
)

@Serializable
data class InternalIncident(
    val id: String,
    val level: IncidentLevel,
    val status: IncidentStatus,
    val title: String,
    val message: String,
    val affectedNetworkId: String?,
    val affectedComponentName: String?,
    val notifyCustomers: Boolean,
    val showAsBanner: Boolean,
    val createdAt: Instant,
    val createdBy: String,
    val events: List<InternalIncidentEvent>,
)

@Serializable
data class InternalIncidentEvent(
    val id: String,
    val level: IncidentLevel,
    val status: IncidentStatus,
    val message: String,
    val createdAt: Instant,
    val createdBy: String,
)

@Resource("/incidents")
class IncidentRoutes {
    @Resource("/public")
    class Public(val parent: IncidentRoutes = IncidentRoutes()) {
        @Serializable
        data class ResponseBody(
            val incidents: List<PublicIncident>,
        )
    }

    @Resource("/internal")
    class Internal(val parent: IncidentRoutes = IncidentRoutes()) {
        @Resource("/get/{incidentId}")
        class Get(val incidentId: String, val parent: Internal = Internal())

        @Resource("/new")
        class New(val parent: Internal = Internal()) {
            @Serializable
            data class RequestBody(
                val level: IncidentLevel,
                val status: IncidentStatus,
                val title: String,
                val message: String,
                val affectedNetworkId: String?,
                val affectedComponentName: String?,
                val notifyCustomers: Boolean,
                val showAsBanner: Boolean,
            )
        }

        @Resource("/update/{incidentId}")
        class Update(val incidentId: String, val parent: Internal = Internal()) {
            @Serializable
            data class RequestBody(
                val title: String,
                val message: String,
            )
        }

        @Resource("/new-event")
        class NewEvent(val parent: Internal = Internal()) {
            @Serializable
            data class RequestBody(
                val incidentId: String,
                val level: IncidentLevel,
                val status: IncidentStatus,
                val message: String,
            )
        }
    }
}
